<template>
<div style="background-color: lightgray" class="container">
  <div class="header-title">
        <span style="position: absolute;left: 2.2rem;top: 1.5rem;" @click="backUp"><van-icon name="revoke"></van-icon></span>
    资金记录
    </div>
    <div class="sub-continner" style="margin-top: 7.8rem;">
      <div class="main-card">
        <div class="main-card-content">
          方法：资金来往记录
          <div>提示：请仔细核对，如有错误，请联系客服</div>
        </div>
      </div>
  <van-row style="background-color: #4d84e2;color: white;height: 44px;">
    <van-col :span="12" style="text-align: center;">
      <div style="font-size: 17px;font-weight: bold;line-height: 1.2;padding-top: 6px;">{{balanceMoney}}</div>
      <span style="font-size: 12px;">钱包余额</span>
    </van-col>
    <van-col :span="12" style="text-align: center;">
      <div style="font-size: 17px;font-weight: bold;line-height: 1.2;padding-top: 6px;">{{cashOutProcMoney || 0}}</div>
      <span style="font-size: 12px;">提现中</span>
    </van-col>
  </van-row>
  <!-- <div style="margin-top: 2%;">
    <van-cell title="申请提现" is-link title-style="color:blue;" :to="{path:'/home/cashoutmoney'}"></van-cell>
  </div> -->
  <div style="margin-top: 2%;">
    <van-tabs v-model="selectTab" class="selectTab" @click="tabSelected">
      <van-tab title="全部">
      </van-tab>
      <van-tab title="充值记录" name="2021080005">
      </van-tab>
      <van-tab title="提现记录" name="2021080004">
      </van-tab>
      <!-- <van-tab title="佣金" name="2021110005">
      </van-tab>
      <van-tab title="推荐" name="2022010007">
      </van-tab>
      <van-tab title="本金" name="2021110004">
      </van-tab> -->
    </van-tabs>
    <!--<van-pull-refresh v-model="refreshing" @refresh="onRefresh">-->
      <div style="overflow-y: scroll;height: 55dvh;">
      <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onRefresh"
      >
        <van-cell v-for="(item, index) in dataList" :key="index" :title="item.title" :label="item.label">
          <template #title>
            <span style="font-size: 13px" >
              <span v-if="item.serialTypeStr != '账户提现' && item.serialTypeStr != '账户充值' && item.serialTypeStr != '转账'">订单编号：<span>{{getStrEndWithNumbers(item.orderId,8)}}</span><br></span>
              <span v-if="item.serialTypeStr != '账户提现' && item.serialTypeStr != '账户充值' && item.serialTypeStr != '转账'">任务编号：<span>{{getStrEndWithNumbers(item.taskId, 8)}}</span><br></span>
              试客：<span>{{item.customerName}}</span><br>
              <!-- 任务类型：<span>{{item.taskTypeStr}}</span><br> -->
              交易类型：{{item.serialTypeStr}}
            </span>
          </template>
          <template #label>
            <div v-if="item.serialTypeStr == '账户提现' || item.serialTypeStr == '账户充值'">
              <span  style="width: 100%;">交易结果：<span style="color: red;">{{item.status=="202111300002"?"审核未通过":item.status=="202111300003"?"审核通过":"待审核"}}</span></span>
              <br>
              <span  style="width: 100%;">审批说明：<span style="color: red;">{{item.remarks}}</span></span><br>
              <span  style="width: 100%;">审批时间：<span style="color: red;">{{item.reviewTime}}</span></span><br>
            </div>
            <div v-if="item.serialTypeStr == '手动结算' || item.serialTypeStr == '手动调整'">
              <span  style="width: 100%;">结算类型：<span style="color: red;">{{item.moneyChangeType?"增加":"减少"}}</span></span><br>
              <span  style="width: 100%;">结算说明：<span style="color: red;">{{item.remarks}}</span></span>
            </div>
            <span style="font-size: 12px;color: #44b1eb">{{item.createTime}}</span>
          </template>
          <template #default>
            金额：<span style="color: red">{{item.serialMoney}}</span>元
          </template>
        </van-cell>
      </van-list>
      </div>
    <!--</van-pull-refresh>-->
  </div>
  </div>
</div>
</template>

<script>
import {queryCustomerAccountLogs} from "../../api/system/sys_personcenter";
import { mixins } from "../../mixins/mixins";

export default {
  name: "PersonMoneyCenter",
  mixins: [mixins],
  data(){
    return {
      selectTab:0,
      loading: false,
      finished: false,
      refreshing: false,
      balanceMoney:0.0,
      cashOutProcMoney: 0.0,
      dataList:[
        {
          title:"jkjkjkfdfdjkfjd",
          value:"121.0",
          label:"2022-01-20"
        }
      ],
      pagination:{
        pageNum: 1,
        pageSize: 20,
        total: null
      },
    }
  },
  mounted() {
    this.$emit("titleChange", "我的钱包");

    this.balanceMoney = this.$route.query.balanceMoney;
    this.cashOutProcMoney = this.$route.query.cashOutProcMoney;
    if (this.$route.query.selected != 0){
      this.selectTab = this.$route.query.selected;
    }else{
      this.selectTab = null;
    }

    queryCustomerAccountLogs({userId: null, serialType:this.selectTab}, this.pagination).then(res=>{
      if (res.success){
        console.log(res.data)
        this.dataList = this.filterDataList(res.data.records);
      }
    }).catch(err => {
      this.$notify({message: err.message, type: 'warning'});
    });
  },
  methods:{
    filterDataList(array){
      console.log(array)
      let arr =  array.filter((item, index, self) => item.serialTypeStr != '佣金返还' && item.serialTypeStr != '本金返还' && item.serialTypeStr != '推荐奖励');
      console.log(arr)
      return arr;
    },
    tabSelected(name, title){
      console.log(name, title)
      if (name == 0) {
        name = null;
      }
      this.pagination.pageNum = 1;
      queryCustomerAccountLogs({userId: null, serialType:name}, this.pagination).then(res=>{
          if (res.success){
            console.log(res.data)
            this.dataList = res.data.records;
          }
        }).catch(err => {
          this.$notify({message: err.message, type: 'warning'});
        });
    },
    onLoad() {
      if (this.selectTab == 0){
        this.selectTab = null;
      }
      if (this.refreshing) {
        this.refreshing = false;
      }
      if (!this.finished){
        this.pagination.pageNum = this.pagination.pageNum + 1;
      }
      queryCustomerAccountLogs({userId: null, serialType:this.selectTab}, this.pagination).then(res=>{
        if (res.success){
          console.log(res.data)
          if (res.data.records.length > 0) {
            this.dataList.push(...this.filterDataList(res.data.records));
          }
          this.loading = false;
          if (res.data.current >= res.data.pages){
            this.finished = true;
          }
        }
      }).catch(err => {
        this.$notify({message: err.message, type: 'warning'});
        this.loading = false;
        this.finished = true;
      });
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
    },
    getStrEndWithNumbers(str, numbers){
      if (str != null){
        let l = str.length;
        return str.substring(l - numbers);
      }else{
        return null;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.selectTab /deep/ .van-tabs--line {
  height: 44px;
}

.selectTab /deep/ .van-tabs__wrap {
  height: 44px;
}
</style>
